import {Component, EventEmitter, Input, Output, Signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NbSelectModule} from '@nebular/theme';
import {Group} from '../../../models/group';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-group-selector',
  standalone: true,
  imports: [
    TranslateModule,NbSelectModule, FormsModule],
  templateUrl: './group-selector.component.html',
  styleUrl: './group-selector.component.scss'
})
export class GroupSelectorComponent {
  @Input() selectedGroupId!: string;
  @Input() groups!: Signal<Group[]>;
  @Output() groupChanged = new EventEmitter();

  getSlideClass(groupId: string): string {
    const currentIndex = this.groups().findIndex(g => g.group_id === this.selectedGroupId);
    const thisIndex = this.groups().findIndex(g => g.group_id === groupId);

    if (thisIndex < currentIndex) {
      return 'slide-left';
    } else if (thisIndex > currentIndex) {
      return 'slide-right';
    } else {
      return 'slide-center';
    }
  }

  groupChange($event: any) {
    if (this.selectedGroupId == $event) return;
    this.selectedGroupId = $event;
    this.groupChanged.emit(this.selectedGroupId);
  }

  getPrevGroupId(): string | null {
    const currentIndex = this.groups().findIndex(g => g.group_id === this.selectedGroupId);
    return currentIndex > 0 ? this.groups()[currentIndex - 1].group_id : null;
  }

  getNextGroupId(): string | null {
    const currentIndex = this.groups().findIndex(g => g.group_id === this.selectedGroupId);
    return currentIndex < this.groups().length - 1 ? this.groups()[currentIndex + 1].group_id : null;
  }
}
